import Model from "./base/model";

class TransporterCodeActions extends Model {
  resourceName() {
    return "transporter_code_actions";
  }

  fields() {
    return {
      transporter_code: "",
      transporter_id: "",
      action_id: "",
      action: { jsonApi: "hasOne", type: "actions"},
    };
  }
}

export default new TransporterCodeActions();
